// import { SvgIcon } from "@mui/material";
import Dashboard from "./pages/dashboard";
import HomeIcon from "@mui/icons-material/Home";
import Signin from "./pages/authentication/signin";
import {
  Engineering,
  Feed,
  SettingsApplications,
  Shop,
  PrecisionManufacturing,
} from "@mui/icons-material";
import AddMotorMake from "./pages/motorMaster/motor-make/components/AddMotorMake";
import EditMotorModel from "./pages/motorMaster/motor-model/EditMotorModel";
import CountryList from "./pages/generalMaster/country/CountryList";
import CountryForm from "./pages/generalMaster/country/CountryForm";
import StateList from "./pages/generalMaster/state/StateList";
import StateForm from "./pages/generalMaster/state/StateForm";
import AddMotorModel from "./pages/motorMaster/motor-model/AddMotorModel";
import ViewMotorModel from "./pages/motorMaster/motor-model/ViewMotorModel";
import AddMotorVariant from "./pages/motorMaster/motor-variant/AddMotorVariant";
import EditMotorVariant from "./pages/motorMaster/motor-variant/EditMotorVariant";
import ViewMotorVariant from "./pages/motorMaster/motor-variant/ViewMotorVariant";
import DistrictList from "./pages/generalMaster/district/DistrictList";
import DistrictForm from "./pages/generalMaster/district/DistrictForm";
import CityList from "./pages/generalMaster/city/CityList";
import CityForm from "./pages/generalMaster/city/CityForm";
import MotorBodyTypeList from "./pages/motorMaster/motor-bodyType/ListMotorBodyType";
import AddMotorBodyType from "./pages/motorMaster/motor-bodyType/AddMotorBodyType";
import EditMotorBodyType from "./pages/motorMaster/motor-bodyType/EditMotorBodyType";
import ViewMotorBodyType from "./pages/motorMaster/motor-bodyType/ViewMotorBodyType";
import MotorBodyStyleList from "./pages/motorMaster/motor-bodyStyle/ListMotorBodyStyle";
import AddMotorBodyStyle from "./pages/motorMaster/motor-bodyStyle/AddMotorBodyStyle";
import EditMotorBodyStyle from "./pages/motorMaster/motor-bodyStyle/EditMotorBodyStyle";
import ViewMotorBodyStyle from "./pages/motorMaster/motor-bodyStyle/ViewMotorBodyStyle";
import MotorRTOList from "./pages/motorMaster/motor-RTO/ListMotorRTO";
import AddMotorRTO from "./pages/motorMaster/motor-RTO/AddMotorRTO";
import EditMotorRTO from "./pages/motorMaster/motor-RTO/EditMotorRTO";
import ViewMotorRTO from "./pages/motorMaster/motor-RTO/ViewMotorRTO";
import GeneralInsurerList from "./pages/generalMaster/general-insurer/ListGeneralInsurer";
import AddGeneralInsurer from "./pages/generalMaster/general-insurer/AddGeneralInsurer";
import EditGeneralInsurer from "./pages/generalMaster/general-insurer/EditGeneralInsurer";
import ViewGeneralInsurer from "./pages/generalMaster/general-insurer/ViewGeneralInsurer";
import GeneralAddonList from "./pages/generalMaster/general-addon/ListGeneralAddon";
import AddGeneralAddon from "./pages/generalMaster/general-addon/AddGeneralAddon";
import EditGeneralAddon from "./pages/generalMaster/general-addon/EditGeneralAddon";
import ViewGeneralAddon from "./pages/generalMaster/general-addon/ViewGeneralAddon";
import GeneralCoverageList from "./pages/generalMaster/general-coverage/ListGeneralCoverage";
import AddGeneralCoverage from "./pages/generalMaster/general-coverage/AddGeneralCoverage";
import EditGeneralCoverage from "./pages/generalMaster/general-coverage/EditGeneralCoverage";
import ViewGeneralCoverage from "./pages/generalMaster/general-coverage/ViewGeneralCoverage";
import GeneralDiscountList from "./pages/generalMaster/general-discount/ListGeneralDiscount";
import AddGeneralDiscount from "./pages/generalMaster/general-discount/AddGeneralDiscount";
import EditGeneralDiscount from "./pages/generalMaster/general-discount/EditGeneralDiscount";
import ViewGeneralDiscount from "./pages/generalMaster/general-discount/ViewGeneralDiscount";
import BankNameList from "./pages/generalMaster/bankName/BankNameList";
import BankNameForm from "./pages/generalMaster/bankName/BankNameForm";
import BankBranchList from "./pages/generalMaster/bankBranch/BankBranchList";
import BankBranchForm from "./pages/generalMaster/bankBranch/BankBranchForm";
import PincodeList from "./pages/generalMaster/pincode/PincodeList";
import PincodeForm from "./pages/generalMaster/pincode/PincodeForm";
import CategoryList from "./pages/generalMaster/category/CategoryList";
import FinanceList from "./pages/generalMaster/finance/FinanceList";
import FinancerForm from "./pages/generalMaster/finance/FinancerForm";
import MotorCategoryList from "./pages/motorMaster/motor-category/ListMotorCategory";
import AddMotorCategory from "./pages/motorMaster/motor-category/AddMotorCategory";
import ViewMotorCategory from "./pages/motorMaster/motor-category/ViewMotorCategory";
import MotorKeyValueList from "./pages/motorMaster/motor-keyValue/ListMotorKeyValue";
import AddMotorKeyValue from "./pages/motorMaster/motor-keyValue/AddMotorKeyValue";
import EditMotorKeyValue from "./pages/motorMaster/motor-keyValue/EditMotorKeyValue";
import ViewMotorKeyValue from "./pages/motorMaster/motor-keyValue/ViewMotorKeyValue";
import KeyValueForm from "./pages/generalMaster/category/KeyValueForm";
import MotorMMVList from "./pages/motorMaster/motor-MMV/ListMotorMMV";
import InsurerAddonList from "./pages/insurerMaster/addon/InsurerAddonList";
import InsurerAddonForm from "./pages/insurerMaster/addon/InsurerAddonForm";
import InsurerCoverageList from "./pages/insurerMaster/coverage/InsurerCoverageList";
import InsurerCoverageForm from "./pages/insurerMaster/coverage/InsurerCoverageForm";
import InsurerBankList from "./pages/insurerMaster/bank/InsurerBankList";
import InsurerBankForm from "./pages/insurerMaster/bank/InsurerBankForm";
import InsurerBranchList from "./pages/insurerMaster/bankBranch/InsurerBranchList";
import InsurerBranchForm from "./pages/insurerMaster/bankBranch/InsurerBranchForm";
import InsurerCountryList from "./pages/insurerMaster/country/InsurerCountryList";
import InsurerCountryForm from "./pages/insurerMaster/country/insurerCountryForm";
import InsurerStateList from "./pages/insurerMaster/state/InsurerStateList";
import InsurerStateForm from "./pages/insurerMaster/state/InsurerStateForm";
import InsurerDistrictList from "./pages/insurerMaster/district/InsurerdistrictList";
import InsurerDistrictForm from "./pages/insurerMaster/district/InsurerdistrictFrom";
import InsurerCityFrom from "./pages/insurerMaster/city/InsurerCityFrom";
import InsurerCityList from "./pages/insurerMaster/city/InsurerCityList";
import PreviousInsurerList from "./pages/insurerMaster/previousInsurer/previousInsurerList";
import InsurerPreviousFrom from "./pages/insurerMaster/previousInsurer/PreviousInsurerFrom";
import InsurerPincodeList from "./pages/insurerMaster/pincode/InsurerPincodeList";
import InsurerPincodeFrom from "./pages/insurerMaster/pincode/InsurerPincodeForm.js";

import InsurerDiscountList from "./pages/insurerMaster/discount/InsurerDiscountList";
import InsurerDiscountForm from "./pages/insurerMaster/discount/InsurerDiscountForm";
import InsurerBodyStyleList from "./pages/insurerMaster/bodyStyle/InsurerBodyStyleList";
import InsurerBodyStyleForm from "./pages/insurerMaster/bodyStyle/InsurerBodyStyleForm";
import InsurerBodyTypeList from "./pages/insurerMaster/bodyType/InsurerBodyTypeList";
import InsurerBodyTypeForm from "./pages/insurerMaster/bodyType/InsurerBodyTypeForm";
import { InsurerMMVList } from "./pages/insurerMaster/mmv/index.jsx";
import AddInsurerMake from "./pages/insurerMaster/mmv/make/component/index.jsx";
import AddInsurerModel from "./pages/insurerMaster/mmv/model/component/index.jsx";
import AddInsurerVariant from "./pages/insurerMaster/mmv/variant/component/index.jsx";
import InsurerFinancer from "./pages/insurerMaster/financer/InsurerFinancerList";

import InsurerFinancerForm from "./pages/insurerMaster/financer/InsurerFinancerForm";
import RtoList from "./pages/insurerMaster/rto/RtoList";
import RtoForm from "./pages/insurerMaster/rto/RtoForm";
import InsurerCategoryList from "./pages/insurerMaster/category/InsurerCategoryList.js";
import InsurerCategoryForm from "./pages/insurerMaster/category/InsurerCategoryForm.js";

import TransformFunctionDictionaryList from "./pages/ApiIntegrationEngine/TransformFunctionDictionary/TransformFunctionDictionaryList.js";
import SchemasList from "./pages/ApiIntegrationEngine/Schemas/SchemasList.js";
import SchemasForm from "./pages/ApiIntegrationEngine/Schemas/SchemasForm.js";
import TransformFunctionDictionaryView from "./pages/ApiIntegrationEngine/TransformFunctionDictionary/TransformFunctionDictionaryView.js";
import ExternalApiRegistryList from "./pages/ApiIntegrationEngine/ExternalApiRegistry/ExternalApiRegistryList.js";
import ExternalApiRegistryForm from "./pages/ApiIntegrationEngine/ExternalApiRegistry/ExternalApiRegistryForm.js";
import InsurerRegistryList from "./pages/ApiIntegrationEngine/InsurerRegistry/InsurerRegistryList.js";
import InsurerRegistryForm from "./pages/ApiIntegrationEngine/InsurerRegistry/InsurerRegistryForm.js";
import FieldDictionaryList from "./pages/ApiIntegrationEngine/FieldDictionary/FieldDictionaryList.js";
import FieldDictionaryForm from "./pages/ApiIntegrationEngine/FieldDictionary/FieldDictionaryForm.js";
import InsurerKeyValueList from "./pages/insurerMaster/keyValue/InsurerKeyValueList.js";
import InsurerKeyValueForm from "./pages/insurerMaster/keyValue/InsurerKeyValueForm.js";
import FieldMappingList from "./pages/ApiIntegrationEngine/FieldMapping/FieldMappingList.js";
import FieldMappingForm from "./pages/ApiIntegrationEngine/FieldMapping/FieldMappingForm.js";
import WorkflowBindingList from "./pages/Operation/WorkflowBinding/WorkflowBindingList.js";
import WorkFlowDictionaryList from "./pages/Operation/WorkflowDictionary/WorkFlowDictionaryList.js";
import WorkflowDictionaryForm from "./pages/Operation/WorkflowDictionary/WorkflowDictionaryForm.js";
import APIendpointsList from "./pages/ApiIntegrationEngine/APIendpoints/APIendpointsList.js";
import APIendpointsForm from "./pages/ApiIntegrationEngine/APIendpoints/APIendpointsForm.js";
import WorkflowBindingForm from "./pages/Operation/WorkflowBinding/WorkflowBindingForm.js";
import WorkflowStepList from "./pages/Operation/WorkflowStep/WorkflowStepList.js";
import WorkflowStepForm from "./pages/Operation/WorkflowStep/WorkflowStepForm.js";
import OperationCategoryList from "./pages/Operation/OperationCategory/OperationCategoryList.js";
import OperationCategoryForm from "./pages/Operation/OperationCategory/OperationCategoryForm.js";
import OperationStoreList from "./pages/Operation/OperationStore/OperationStoreList.js";
import OperationStoreForm from "./pages/Operation/OperationStore/OperationStoreForm.js";
import ApiCategoryList from "./pages/ApiIntegrationEngine/Category/ApiCategoryList.js";
import ApiStoreList from "./pages/ApiIntegrationEngine/Store/ApiStoreList.js";
import ApiCategoryForm from "./pages/ApiIntegrationEngine/Category/ApiCategoryForm.js";
import ApiStoreForm from "./pages/ApiIntegrationEngine/Store/ApiStoreForm.js";
import WorkflowStepDependencyForm from "./pages/Operation/WorkflowStepDependency/WorkflowStepDependencyForm.js";
import WorkflowStepDependencyList from "./pages/Operation/WorkflowStepDependency/WorkflowStepDependencyList.js";
import APIoperationsList from "./pages/ApiIntegrationEngine/APIoperations/APIoperationsList.js";
import APIoperationsForm from "./pages/ApiIntegrationEngine/APIoperations/APIoperationsForm.js";
import AuthLoader from "./pages/authentication/Authloader.jsx";

const routes = [
  {
    name: "Authentication",
    key: "authentication",
    collapse: [
      {
        name: "Sign in",
        key: "cspua",
        route: "/cspua",
        component: <AuthLoader />,
      },
    ],
  },
  {
    type: "collapse",
    icon: <HomeIcon />,
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    component: <Dashboard />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "collapse",
    name: "Motor Master",
    key: "motor-master",
    icon: <Shop size="12px" />,
    collapse: [
      {
        name: "Body Type",
        key: "motor-bodyType",
        route: "/motor-master/motor-bodyType",
        component: <MotorBodyTypeList />,
      },
      {
        name: "Body Style",
        key: "motor-bodyStyle",
        route: "/motor-master/motor-bodyStyle",
        component: <MotorBodyStyleList />,
      },
      {
        name: "Motor MMV",
        key: "motor-MMV",
        route: "/motor-master/motor-MMV",
        component: <MotorMMVList />,
      },
      {
        name: "Motor RTO",
        key: "motor-RTO",
        route: "/motor-master/motor-RTO",
        component: <MotorRTOList />,
      },
      {
        name: "Motor Category",
        key: "motor-category",
        route: "/motor-master/motor-category",
        component: <MotorCategoryList />,
      },
      {
        name: "Motor Key Value",
        key: "motor-keyValue",
        route: "/motor-master/motor-keyValue",
        component: <MotorKeyValueList />,
      },
    ],
  },
  {
    type: "collapse",
    name: "General Master",
    key: "general-master",
    icon: <Engineering size="12px" />,
    collapse: [
      {
        name: "Insurer",
        key: "general-insurer",
        route: "/general-master/general-insurer",
        component: <GeneralInsurerList />,
      },
      {
        name: "Country",
        key: "country-list",
        route: "/general-master/country-list",
        component: <CountryList />,
      },
      {
        name: "State",
        key: "state-list",
        route: "/general-master/state-list",
        component: <StateList />,
      },
      {
        name: "District",
        key: "district-list",
        route: "/general-master/district-list",
        component: <DistrictList />,
      },
      {
        name: "City",
        key: "city-list",
        route: "/general-master/city-list",
        component: <CityList />,
      },
      {
        name: "PIN Code",
        key: "pincode-list",
        route: "/general-master/pincode-list",
        component: <PincodeList />,
      },
      {
        name: "Add On",
        key: "general-addon",
        route: "/general-master/general-addon",
        component: <GeneralAddonList />,
      },
      {
        name: "Coverage",
        key: "general-coverage",
        route: "/general-master/general-coverage",
        component: <GeneralCoverageList />,
      },
      {
        name: "Discount",
        key: "general-discount",
        route: "/general-master/general-discount",
        component: <GeneralDiscountList />,
      },
      {
        name: "Bank",
        key: "bank-list",
        route: "/general-master/bank-list",
        component: <BankNameList />,
      },
      {
        name: "Bank Branch",
        key: "bank-branch-list",
        route: "/general-master/bank-branch-list",
        component: <BankBranchList />,
      },
      {
        name: "Finance Master",
        key: "financer-list",
        route: "/general-master/financer-list",
        component: <FinanceList />,
      },
      {
        name: "Category Master",
        key: "category-list",
        route: "/general-master/category-list",
        component: <CategoryList />,
      },
    ],
  },
  {
    name: "Add Insurer",
    key: "add-insurer",
    route: "/general-master/general-insurer/add-insurer",
    component: <AddGeneralInsurer />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Edit Insurer",
    key: "edit-insurer",
    route: "/general-master/general-insurer/edit-insurer/:id",
    component: <EditGeneralInsurer />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "View Insurer",
    key: "view-insurer",
    route: "/general-master/general-insurer/view-insurer/:id",
    component: <ViewGeneralInsurer />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add Insurer",
    key: "add-insurer",
    route: "/general-master/general-insurer/add-insurer",
    component: <AddGeneralInsurer />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add Addon",
    key: "general-addon",
    route: "/general-master/general-addon/add-addon",
    component: <AddGeneralAddon />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Edit Addon",
    key: "general-addon",
    route: "/general-master/general-addon/edit-addon/:id",
    component: <EditGeneralAddon />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "View Addon",
    key: "general-addon",
    route: "/general-master/general-addon/view-addon/:id",
    component: <ViewGeneralAddon />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add Coverage",
    key: "add-coverage",
    route: "/general-master/general-coverage/add-coverage",
    component: <AddGeneralCoverage />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Edit Coverage",
    key: "general-coverage",
    route: "/general-master/general-coverage/edit-coverage/:id",
    component: <EditGeneralCoverage />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "View Coverage",
    key: "general-coverage",
    route: "/general-master/general-coverage/view-coverage/:id",
    component: <ViewGeneralCoverage />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add Discount",
    key: "add-discount",
    route: "/general-master/general-discount/add-discount",
    component: <AddGeneralDiscount />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Edit Discount",
    key: "general-discount",
    route: "/general-master/general-discount/edit-discount/:id",
    component: <EditGeneralDiscount />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "View Discount",
    key: "general-discount",
    route: "/general-master/general-discount/view-discount/:id",
    component: <ViewGeneralDiscount />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Country Details",
    key: "country-details",
    route: "/general-master/country-list/country-details",
    component: <CountryForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "State Details",
    key: "state-details",
    route: "/general-master/state-list/state-details",
    component: <StateForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "District Details",
    key: "district-details",
    route: "/general-master/district-list/district-details",
    component: <DistrictForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "City Details",
    key: "city-details",
    route: "/general-master/city-list/city-details",
    component: <CityForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Pin Code Details",
    key: "pincode-details",
    route: "/general-master/pincode-list/pincode-details",
    component: <PincodeForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Bank Name Details",
    key: "bank-details",
    route: "/general-master/bank-list/bank-details",
    component: <BankNameForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Bank Branch Details",
    key: "bank-branch-details",
    route: "/general-master/bank-branch-list/bank-branch-details",
    component: <BankBranchForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Financer Details",
    key: "financer-details",
    route: "/general-master/financer-list/financer-details",
    component: <FinancerForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Key Value Details",
    key: "key-value-details",
    route: "/general-master/category-list/key-value-details",
    component: <KeyValueForm />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "collapse",
    name: "Insurer Master",
    key: "insurer-master",
    icon: <Feed size="12px" />,
    collapse: [
      {
        name: "Insurer Category",
        key: "insurer-category",
        route: "/insurer-master/insurer-category",
        component: <InsurerCategoryList />,
      },
      {
        name: "Insurer Key Value",
        key: "insurer-key-value",
        route: "/insurer-master/insurer-key-value",
        component: <InsurerKeyValueList />,
      },
      {
        name: "Previous Insurer",
        key: "insurer-previous-insurer",
        route: "/insurer-master/insurer-previous-insurer",
        component: <PreviousInsurerList />,
      },
      {
        name: "Body Type",
        key: "body-type",
        route: "/insurer-master/body-type",
        component: <InsurerBodyTypeList />,
      },
      {
        name: "Body Style",
        key: "body-style",
        route: "/insurer-master/body-style",
        component: <InsurerBodyStyleList />,
      },
      {
        name: "Insurer MMV",
        key: "insurer-motor-mmv",
        route: "/insurer-master/insurer-motor-mmv",
        component: <InsurerMMVList />,
      },
      {
        name: "Country",
        key: "insurer-country",
        route: "/insurer-master/insurer-country",
        component: <InsurerCountryList />,
      },
      {
        name: "State",
        key: "insurer-state",
        route: "/insurer-master/insurer-state",
        component: <InsurerStateList />,
      },
      {
        name: "District",
        key: "insurer-district",
        route: "/insurer-master/insurer-district",
        component: <InsurerDistrictList />,
      },
      {
        name: "City",
        key: "insurer-city",
        route: "/insurer-master/insurer-city",
        component: <InsurerCityList />,
      },

      {
        name: "PIN Code",
        key: "insurer-pincode",
        route: "/insurer-master/insurer-pincode",
        component: <InsurerPincodeList />,
      },
      {
        name: "RTO",
        key: "insurer-rto",
        route: "/insurer-master/insurer-rto",
        component: <RtoList />,
      },
      {
        name: "Financer",
        key: "insurer-financer",
        route: "/insurer-master/insurer-financer",
        component: <InsurerFinancer />,
      },
      {
        name: "Insurer Addon",
        key: "insurer-addon",
        route: "/insurer-master/insurer-addon",
        component: <InsurerAddonList />,
      },
      {
        name: "Insurer Coverage",
        key: "insurer-coverage",
        route: "/insurer-master/insurer-coverage",
        component: <InsurerCoverageList />,
      },
      {
        name: "Insurer Discount",
        key: "insurer-discount",
        route: "/insurer-master/insurer-discount",
        component: <InsurerDiscountList />,
      },
      {
        name: "Insurer Bank",
        key: "insurer-bank",
        route: "/insurer-master/insurer-bank",
        component: <InsurerBankList />,
      },
      {
        name: "Insurer Bank Branch",
        key: "insurer-branch",
        route: "/insurer-master/insurer-branch",
        component: <InsurerBranchList />,
      },      
    ],
  },
  {
    name: "Add Insurer Make",
    key: "add-insurer-make",
    route: "/insurer-master/insurer-motor-mmv/add-insurer-make",
    component: <AddInsurerMake />,
    noCollapse: true,
    protected: true,
  },

  {
    name: "Add Insurer Model",
    key: "add-insurer-model",
    route: "/insurer-master/insurer-motor-mmv/add-insurer-model",
    component: <AddInsurerModel />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add Insurer Variant",
    key: "add-insurer-variant",
    route: "/insurer-master/insurer-motor-mmv/add-insurer-variant",
    component: <AddInsurerVariant />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Addon Details",
    key: "addon-details",
    route: "/insurer-master/insurer-addon/addon-details",
    component: <InsurerAddonForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Coverage Details",
    key: "coverage-details",
    route: "/insurer-master/insurer-coverage/coverage-details",
    component: <InsurerCoverageForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Discount Details",
    key: "discount-details",
    route: "/insurer-master/insurer-discount/discount-details",
    component: <InsurerDiscountForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Bank Details",
    key: "bank-details",
    route: "/insurer-master/insurer-bank/bank-details",
    component: <InsurerBankForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Bank Branch Details",
    key: "branch-details",
    route: "/insurer-master/insurer-branch/branch-details",
    component: <InsurerBranchForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Body Type",
    key: "body-type-details",
    route: "/insurer-master/body-type/body-type-details",
    component: <InsurerBodyTypeForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Body Style",
    key: "body-style-details",
    route: "/insurer-master/body-style/body-style-details",
    component: <InsurerBodyStyleForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add Discount",
    key: "add-discount",
    route: "/insurer-master/insurer-country/add-country",
    component: <InsurerCountryForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add State",
    key: "add-state",
    route: "/insurer-master/insurer-state/add-state",
    component: <InsurerStateForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add District",
    key: "add-district",
    route: "/insurer-master/insurer-district/add-district",
    component: <InsurerDistrictForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add City",
    key: "add-city",
    route: "/insurer-master/insurer-city/add-city",
    component: <InsurerCityFrom />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add Insurer Category",
    key: "add-category",
    route: "/insurer-master/insurer-category/add-category",
    component: <InsurerCategoryForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Key Value Details",
    key: "key-value-details",
    route: "/insurer-master/insurer-key-value/key-value-details",
    component: <InsurerKeyValueForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add Previous Insurer",
    key: "add-previous-insurer",
    route: "/insurer-master/insurer-previous-insurer/add-previous-insurer",
    component: <InsurerPreviousFrom />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add Financer",
    key: "add-financer",
    route: "/insurer-master/insurer-financer/add-financer",
    component: <InsurerFinancerForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add RTO",
    key: "add-rto",
    route: "/insurer-master/insurer-rto/add-rto",
    component: <RtoForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add Pincode Insurer",
    key: "add-pincode-insurer",
    route: "/insurer-master/insurer-pincode/add-pincode-insurer",
    component: <InsurerPincodeFrom />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Add Pincode Insurer",
    key: "add-pincode-insurer",
    route: "/insurer-master/insurer-pincode/add-pincode-insurer",
    component: <InsurerPincodeFrom />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "AddMake",
    key: "add-make",
    route: "/motor-master/add-make",
    component: <AddMotorMake />,
    protected: true,
  },
  {
    type: "EditMake",
    key: "edit-make",
    route: "/motor-master/edit-make/:id",
    component: <AddMotorMake />,
    protected: true,
  },
  {
    type: "ViewMake",
    key: "view-make",
    route: "/motor-master/view-make/:id",
    component: <AddMotorMake />,
    protected: true,
  },
  {
    type: "AddModel",
    key: "add-model",
    route: "/motor-master/add-model",
    component: <AddMotorModel />,
    protected: true,
  },
  {
    type: "EditModel",
    key: "edit-model",
    route: "/motor-master/edit-model/:id",
    component: <EditMotorModel />,
    protected: true,
  },
  {
    type: "ViewModel",
    key: "view-model",
    route: "/motor-master/view-model/:id",
    component: <ViewMotorModel />,
    protected: true,
  },
  {
    type: "AddBodyType",
    key: "add-bodyType",
    route: "/motor-master/add-bodyType",
    component: <AddMotorBodyType />,
    protected: true,
  },
  {
    type: "EditBodyType",
    key: "edit-bodyType",
    route: "/motor-master/edit-bodyType/:id",
    component: <EditMotorBodyType />,
    protected: true,
  },
  {
    type: "ViewBodyType",
    key: "view-bodyType",
    route: "/motor-master/view-bodyType/:id",
    component: <ViewMotorBodyType />,
    protected: true,
  },
  {
    type: "AddBodyStyle",
    key: "add-bodyStyle",
    route: "/motor-master/add-bodyStyle",
    component: <AddMotorBodyStyle />,
    protected: true,
  },
  {
    type: "EditBodyStyle",
    key: "edit-bodyStyle",
    route: "/motor-master/edit-bodyStyle/:id",
    component: <EditMotorBodyStyle />,
    protected: true,
  },
  {
    type: "ViewBodyStyle",
    key: "view-bodyStyle",
    route: "/motor-master/view-bodyStyle/:id",
    component: <ViewMotorBodyStyle />,
    protected: true,
  },
  {
    type: "AddVariant",
    key: "add-variant",
    route: "/motor-master/add-variant",
    component: <AddMotorVariant />,
    protected: true,
  },
  {
    type: "EditVariant",
    key: "edit-variant",
    route: "/motor-master/edit-variant/:id",
    component: <EditMotorVariant />,
    protected: true,
  },
  {
    type: "ViewVariant",
    key: "view-variant",
    route: "/motor-master/view-variant/:id",
    component: <ViewMotorVariant />,
    protected: true,
  },
  {
    type: "AddMotorRTO",
    key: "add-motorRTO",
    route: "/motor-master/add-motorRTO",
    component: <AddMotorRTO />,
    protected: true,
  },
  {
    type: "EditMotorRTO",
    key: "edit-motorRTO",
    route: "/motor-master/edit-motorRTO/:id",
    component: <EditMotorRTO />,
    protected: true,
  },
  {
    type: "ViewMotorRTO",
    key: "view-motorRTO",
    route: "/motor-master/view-motorRTO/:id",
    component: <ViewMotorRTO />,
    protected: true,
  },
  {
    type: "AddCategory",
    key: "add-category",
    route: "/motor-master/motor-category/add-category",
    component: <AddMotorCategory />,
    protected: true,
  },
  {
    type: "ViewCategory",
    key: "view-category",
    route: "/motor-master/motor-category/view-category/:id",
    component: <ViewMotorCategory />,
    protected: true,
  },
  {
    type: "AddKeyValue",
    key: "add-keyValue",
    route: "/motor-master/motor-keyValue/add-keyValue",
    component: <AddMotorKeyValue />,
    protected: true,
  },
  {
    type: "EditKeyValue",
    key: "edit-keyValue",
    route: "/motor-master/motor-keyValue/edit-keyValue/:id",
    component: <EditMotorKeyValue />,
    protected: true,
  },
  {
    type: "ViewKeyValue",
    key: "view-keyValue",
    route: "/motor-master/motor-keyValue/view-keyValue/:id",
    component: <ViewMotorKeyValue />,
    protected: true,
  },
  {
    type: "collapse",
    name: "API Integration engine",
    key: "api-integration-engine",
    icon: <SettingsApplications size="12px" />,
    collapse: [
      {
        name: "Category",
        key: "key-value-category",
        route: "/api-integration-engine/key-value-category",
        component: <ApiCategoryList />,
      },
      {
        name: "Store",
        key: "key-value-store",
        route: "/api-integration-engine/key-value-store",
        component: <ApiStoreList />,
      },
      {
        name: "Insurer Registry",
        key: "insurer-registry",
        route: "/api-integration-engine/insurer-registry",
        component: <InsurerRegistryList />,
      },
      {
        name: "Transform Function Dictionary",
        key: "transform-function-dictionary",
        route: "/api-integration-engine/transform-function-dictionary",
        component: <TransformFunctionDictionaryList />,
      },
      {
        name: "Schemas",
        key: "schemas",
        route: "/api-integration-engine/schemas",
        component: <SchemasList />,
      },
      {
        name: "Api Registry",
        key: "external-api-registry",
        route: "/api-integration-engine/external-api-registry",
        component: <ExternalApiRegistryList />,
      },
      {
        name: "API Endpoints",
        key: "external-api-endpoints",
        route: "/api-integration-engine/external-api-endpoints",
        component: <APIendpointsList />,
      },
      {
        name: "API Operations",
        key: "external-api-operations",
        route: "/api-integration-engine/external-api-operations",
        component: <APIoperationsList />,
      },
      {
        name: "Field Dictionary",
        key: "field-dictionary",
        route: "/api-integration-engine/field-dictionary",
        component: <FieldDictionaryList />,
      },
      {
        name: "Field Mapping",
        key: "field-mapping",
        route: "/api-integration-engine/field-mapping",
        component: <FieldMappingList />,
      },
    ],
  },
  {
    name: "API Engine Category Details",
    key: "category-details",
    route: "/api-integration-engine/key-value-category/category-details",
    component: <ApiCategoryForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "API Engine Store Details",
    key: "store-details",
    route: "/api-integration-engine/key-value-store/store-details",
    component: <ApiStoreForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Insurer Registry Details",
    key: "insurer-registry-details",
    route: "/api-integration-engine/insurer-registry/insurer-registry-details",
    component: <InsurerRegistryForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Shemas Details",
    key: "Shemas-details",
    route: "/api-integration-engine/schemas/schemas-details",
    component: <SchemasForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Transform Dictionary Details",
    key: "transform-dictionary-details",
    route:
      "/api-integration-engine/transform-function-dictionary/transform-dictionary-details",
    component: <TransformFunctionDictionaryView />,
    noCollapse: true,
    protected: true,
  },

  {
    name: "External API endpoints",
    key: "external-api-endpoints-details",
    route:
      "/api-integration-engine/external-api-endpoints/external-api-endpoints-details",
    component: <APIendpointsForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "External API operations",
    key: "external-api-operations-details",
    route:
      "/api-integration-engine/external-api-operations/external-api-operations-details",
    component: <APIoperationsForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "External Api Registry Details",
    key: "external-api-registry-details",
    route:
      "/api-integration-engine/external-api-registry/external-api-registry-details",
    component: <ExternalApiRegistryForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Field Dictionary Details",
    key: "field-dictionary-details",
    route: "/api-integration-engine/field-dictionary/field-dictionary-details",
    component: <FieldDictionaryForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Field Mapping Details",
    key: "field-mapping-details",
    route: "/api-integration-engine/field-mapping/field-mapping-details",
    component: <FieldMappingForm />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "collapse",
    name: "Operation",
    key: "operation",
    icon: <PrecisionManufacturing size="12px" />,
    collapse: [
      {
        name: "Operation Category",
        key: "operation-category",
        route: "/operation/operation-category",
        component: <OperationCategoryList />,
      },
      {
        name: "Operation Store",
        key: "operation-store",
        route: "/operation/operation-store",
        component: <OperationStoreList />,
      },
      {
        name: "Workflow Dictionary",
        key: "workflow-dictionary",
        route: "/operation/workflow-dictionary",
        component: <WorkFlowDictionaryList />,
      },
      {
        name: "Workflow Step",
        key: "workflow-step",
        route: "/operation/workflow-step",
        component: <WorkflowStepList />,
      },
      {
        name: "Workflow Step Dependency",
        key: "workflow-step-dependency",
        route: "/operation/workflow-step-dependency",
        component: <WorkflowStepDependencyList />,
      },      
      {
        name: "Workflow Binding",
        key: "workflow-binding",
        route: "/operation/workflow-binding",
        component: <WorkflowBindingList />,
      },
    ],
  },
  {
    name: "Operation Category Details",
    key: "operation-category-details",
    route: "/operation/operation-category/operation-category-details",
    component: <OperationCategoryForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Operation Store Details",
    key: "operation-store-details",
    route: "/operation/operation-store/operation-store-details",
    component: <OperationStoreForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Workflow Dictionary Details",
    key: "workflow-dictionary-details",
    route: "/operation/workflow-dictionary/workflow-dictionary-details",
    component: <WorkflowDictionaryForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Workflow Binding Details",
    key: "workflow-binding-details",
    route: "/operation/workflow-binding/workflow-binding-details",
    component: <WorkflowBindingForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Workflow Step Details",
    key: "workflow-step-details",
    route: "/operation/workflow-step/workflow-step-details",
    component: <WorkflowStepForm />,
    noCollapse: true,
    protected: true,
  },
  {
    name: "Workflow Step Dependency Details",
    key: "step-dependency-details",
    route: "/operation/workflow-step-dependency/step-dependency-details",
    component: <WorkflowStepDependencyForm />,
    noCollapse: true,
    protected: true,
  },
];
export default routes;
